import React from "react";
import { stepTwoData } from "../stepsData";
import { Typography } from "@mui/material";
import { headingStyle, paragraphStyle } from "../../../../calculatorStyleData";

const StepTwo = () => {
  return (
    <>
      <div id="step-two" className="mt-5">
        <div id="list_data" className="mt-3">
          <Typography sx={headingStyle} className="pb-3">
            <strong>{stepTwoData[0].heading}</strong>
          </Typography>
          <Typography sx={paragraphStyle}>
            {stepTwoData[0].subheading}
          </Typography>
          <div>
            <ol
              style={{
                listStyle: "number",
                fontSize: 16,
                color: "#1f1f1f",
                lineHeight: "24px",
              }}
              className=" archivo "
            >
              {stepTwoData[0].infoList &&
                stepTwoData[0].infoList.map((item, index) => (
                  <li key={index} className="mt-3">
                    <Typography sx={paragraphStyle}>
                      <strong>{item.info}</strong> {item.description}
                    </Typography>
                  </li>
                ))}
            </ol>
          </div>
        </div>
        <div id="list_data" className="mt-3">
          <Typography sx={headingStyle}>
            <strong>{stepTwoData[0].secondHeading}</strong>
          </Typography>

          <div>
            <ol
              style={{
                listStyle: "number",
                fontSize: 16,
                color: "#1f1f1f",
                lineHeight: "24px",
              }}
              className=" archivo "
            >
              {stepTwoData[0].secondInfoList &&
                stepTwoData[0].secondInfoList.map((item, index) => (
                  <li key={index} className="mt-3">
                    <Typography sx={paragraphStyle}>
                      {" "}
                      <strong>{item.info}</strong> {item.description}
                    </Typography>
                  </li>
                ))}
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepTwo;
